import clsx from 'clsx'

import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text'

import type { FC } from 'react'

interface DownloadDecreeBlockProps
  extends React.HTMLAttributes<HTMLDivElement> {}

const links = [
  {
    title: 'Surat Pengumuman',
    url: `${process.env.NEXT_PUBLIC_CP_CDN}/public-document/Surat%20Pengumuman.pdf`,
  },
  {
    title: 'Surat Rekomendasi',
    url: `${process.env.NEXT_PUBLIC_CP_CDN}/public-document/Surat%20Rekomendasi.pdf`,
  },
]

const DownloadDecreeBlock: FC<DownloadDecreeBlockProps> = ({ className }) => {
  return (
    <div className={clsx('space-y-2', className)}>
      {links.map((thisLink, index) => (
        <div
          className="bg-gray-5 rounded px-3 py-3.5 flex space-x-[15px]"
          key={`link_${index}`}
        >
          <Icon as="i" color="inherit">
            text_snippet_outlined
          </Icon>
          <Text variant="body">
            Cek{' '}
            <a
              className="text-blue-70 hover:underline"
              target="_blank"
              href={thisLink.url}
              rel="noopener noreferrer"
            >
              {thisLink.title}
            </a>
          </Text>
        </div>
      ))}
    </div>
  )
}
export default DownloadDecreeBlock
